import { action } from 'satcheljs';
import { MailboxInfo } from 'owa-client-ids';

export const updateInitialParameters = action(
    'updateInitialParameters',
    (mailboxInfo: MailboxInfo, scenarioName: string) => ({
        mailboxInfo: mailboxInfo,
        scenarioName: scenarioName,
    })
);

export const selectColumnSortAction = action('selectColumnSortAction', (value: number[]) => ({
    value: value,
}));
